import * as React from 'react'
import styled from 'styled-components'

// COMPONENTS

const Input = styled.input`
  background-color: var(--primary-lighter);
  color: var(--primary);
  width: 24px;
  height: 24px;
  border-radius: calc(var(--spacing) * 2);
  margin-right: 6px;
`
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`

const Checkbox = ({ children, required, value, onChange }) => {
  return (
    <StyledContainer>
      <Input
        onChange={onChange}
        value={value}
        type="checkbox"
        required={required === true}
      />{' '}
      {children}
    </StyledContainer>
  )
}

export default Checkbox
